/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const StateCodeTypeFormatter = (cellContent, row, rowIndex) => {
  const { state_code } = row || {};
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <span className="text-dark-75 d-block text-capitalize">{`${
            state_code ? state_code : "-"
          }`}</span>
        </div>
      </div>
      <> </>
    </>
  );
};
